import React, {useState} from 'react';
import {Chip, TextField} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    inputRoot: {
        flexWrap: 'wrap',
        gap: theme.spacing(0.5),
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    chip: {
        margin: theme.spacing(0.25),
    },
    input: {
        minWidth: 140,
        flex: 1,
    },
}));

const normalizeValues = (values) => [...new Set((values || [])
    .map((value) => (value || '').trim())
    .filter(Boolean))];

export default function StringArrayInput({label, name, value = [], onChange, fullWidth = false}) {
    const classes = useStyles();
    const [inputValue, setInputValue] = useState('');
    const values = normalizeValues(value);

    const updateValues = (nextValues) => {
        onChange(name, normalizeValues(nextValues));
    };

    const commitInput = () => {
        const pendingValue = inputValue.trim();
        if (!pendingValue) return;
        updateValues([...values, pendingValue]);
        setInputValue('');
    };

    const handleKeyDown = (event) => {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        commitInput();
    };

    const handleDelete = (deletedValue) => {
        updateValues(values.filter((currentValue) => currentValue !== deletedValue));
    };

    return (
        <TextField
            variant="outlined"
            label={label}
            name={name}
            value={inputValue}
            onChange={(event) => setInputValue(event.target.value)}
            onKeyDown={handleKeyDown}
            onBlur={commitInput}
            fullWidth={fullWidth}
            InputLabelProps={(values.length || inputValue) ? {shrink: true} : undefined}
            InputProps={{
                classes: {root: classes.inputRoot},
                startAdornment: values.map((currentValue) => (
                    <Chip
                        key={currentValue}
                        label={currentValue}
                        onDelete={() => handleDelete(currentValue)}
                        className={classes.chip}
                        onMouseDown={(event) => event.preventDefault()}
                    />
                )),
            }}
            inputProps={{className: classes.input}}
        />
    );
}
